import React, {Component} from 'react';
import './home.styles.css';
import {Link} from "react-router-dom";
class HomeComponent extends Component {
    render() {
        return (
            <div className="main-container">
                <div className="container d-flex flex-column">
                    <main className="cover">
                        <h1 className="display-4 text-center">The Sanctuary of Tomorrow</h1>
                        <p className="lead">Hello, my name is Aayush Soni, the founder of "The Sanctuary of Tomorrow".
                            I am here to help those who face problems in finding best resources,
                            online courses, and best learning material.</p>
                        <p className="lead">
                            <Link className="btn btn-lg btn-outline-light" to="/about-us">About Us</Link>
                        </p>
                    </main>
                </div>
            </div>
        );
    }
}

export default HomeComponent;